import {DOM} from "../../../../public/js/utils/DOM";

export namespace ControlsGeneralSideNavControl {

    export class Config {

        public static readonly sideNavComponentId = 'sideNav';
        public static readonly activeClassName = 'active';
        public static readonly mobileMenuCloseTriggerElementId = 'SideNavControl-mobileMenu-hide';
    }

    export class Control {

        static triggerToggleMenu() : void {

            this.triggerMobileHide();
            this.triggerMinimizer();
        }

        /**
         * Hide left menu
         */
        static actionHideMenu() : void {
            DOM.Parser.getHtmlElement(Config.sideNavComponentId).classList.remove(Config.activeClassName);
        }

        /**
         * Show left menu
         */
        static actionShowMenu() : void {
            DOM.Parser.getHtmlElement(Config.sideNavComponentId).classList.add(Config.activeClassName);
        }

        private static triggerMobileHide() {

            const trigger = DOM.Parser.getHtmlElement(Config.mobileMenuCloseTriggerElementId);
            trigger.addEventListener('click', (event: MouseEvent) => {

                event.stopPropagation();
                event.preventDefault();
                this.actionHideMenu();
            });
        }

        /**
         * Minimize sideNav on desktop functionality
         * @private
         */
        private static triggerMinimizer() : void {

            const minimizer = DOM.Parser.getHtmlElement('sideNavDesktopMinimizer');
            const body = DOM.Parser.getBodyElement();
            minimizer.addEventListener('click', () => {
                if (DOM.Parser.getDataByNameFromElement('state', minimizer).toString().toLowerCase() === 'off') {
                    body.classList.add('sideNavMinimized');
                    minimizer.setAttribute('data-state', 'on');
                } else {
                    body.classList.remove('sideNavMinimized');
                    minimizer.setAttribute('data-state', 'off');
                }
            });
        }
    }
}